import { Typography } from "@mui/material";
import { PipelinePickup } from "../types";
import { format, parseISO } from "date-fns";

type Props = {
  pickup: PipelinePickup;
};

export function PickedUpCardContent({ pickup }: Props) {
  return (
    <Typography variant="body2" color="text.secondary" mt={1.5} sx={{ fontSize: 13, lineHeight: 1.4 }}>
      Picked up{" "}
      <Typography component="span" variant="body2" fontWeight={600} color="text.primary" sx={{ fontSize: 13 }}>
        {format(parseISO(pickup.pickedUpAt ?? ""), "MMM d - h:mm a z")}
      </Typography>
    </Typography>
  );
}
